var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "light-theme": _vm.light } },
    [
      _vm.isAuthenticated
        ? _c(
            "router-link",
            {
              staticClass: "agreement-link",
              attrs: { to: _vm.accountRoute.home },
            },
            [_vm._v(_vm._s(_vm.accountResource.account))]
          )
        : [
            _c(
              "router-link",
              {
                staticClass: "agreement-link",
                attrs: { to: _vm.accountRoute.login },
              },
              [_vm._v(_vm._s(_vm.accountResource.login))]
            ),
            _c("span", { staticClass: "agreement-link-text" }, [_vm._v(" / ")]),
            _c(
              "router-link",
              {
                staticClass: "agreement-link",
                attrs: { to: _vm.accountRoute.register },
              },
              [_vm._v(_vm._s(_vm.accountResource.register))]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }